import defineMessages from "../../../common/helpers/defineMessages";

const messages = defineMessages({
    title: {
        id: "error.404.title",
    },
    p: {
        id: "error.404.p",
    },
});

export default messages;
